import {
  SchoolIDState,
  ClassIDState,
  ClassStudentsState,
  StudentIDState,
} from "global-states";
import { useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useRecoilValue, useSetRecoilState } from "recoil";

export function useLocationParams() {
  const l = useParams<{ uid?: string }>();
  const setSchoolID = useSetRecoilState(SchoolIDState);
  useEffect(() => {
    setSchoolID(l?.uid || "");
  }, [l?.uid, setSchoolID]);
}

export function useInitLocationParams() {
  const { search } = useLocation();
  const setClassID = useSetRecoilState(ClassIDState);
  const setStudentID = useSetRecoilState(StudentIDState);
  const students = useRecoilValue(ClassStudentsState);

  useEffect(() => {
    if (search.includes("class_id")) {
      const classID = search.replaceAll("?class_id=", "");
      setClassID(classID);
      if (students && students.length) {
        setStudentID(students[0].student_id);
      }
    }
  }, [search, setClassID, setStudentID, students]);
}
